import { Source } from "definitions/product-storage";
import { API } from "src/api";

import type { LinkPlatform } from "./filterLinks";

export async function convertLinkToSpuIdJob(
  link: string,
  platform: LinkPlatform,
): Promise<number> {
  if (platform === Source.Shihuo) {
    return Number(new URL(link).searchParams.get("goodsId"));
  }

  if (platform === Source.Goat) {
    // goat отдаёт два вида ссылок: /sneakers/<productTemplateId> (id прямо в URL)
    // и /sneakers/<slug> (id резолвится ручкой)
    const idOrSlug =
      new URL(link).pathname.split("/").filter(Boolean).pop() ?? "";
    if (/^\d+$/.test(idOrSlug)) {
      return Number(idOrSlug);
    }
    return API.goatApi
      .goatGetProductTemplate(idOrSlug)
      .then((data) => Number(data.data.id));
  }

  return API.poizonPublicApi
    .dewuControllerConvertLinkToSpuId(link)
    .then((data) => data.data.spuId);
}

export const convertSpuIdToProductIdJob = (
  id: string,
  platform: LinkPlatform,
) =>
  API.productStorageApi
    .productControllerGetProductDetailsByExternalId({
      externalId: id,
      source: platform,
    })
    .then((data) => data.data.productId);
